import { useLocation, useNavigate, useSearchParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { capitalizeText, cn } from '~/utils/misc'
import { searchBoxFilterStyle } from './searchbox.helper'
import { useCategories } from '~/utils/categories'
import { useUserQueries } from '~/utils/queries/userUrlQueries'

export default function SearchBoxCategorySelect() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const location = useLocation()
	const [searchParams] = useSearchParams()
	const categories = useCategories()
	const { categories: selectedCategories } = useUserQueries()

	// Handle change event for the select element
	function handleChange(e: React.ChangeEvent<HTMLSelectElement>) {
		const selectedCategory = e.target.value
		const newSp = new URLSearchParams(searchParams.toString())

		if (selectedCategory) {
			newSp.set('categories', selectedCategory)
		} else {
			newSp.delete('categories')
		}

		navigate(
			`${location?.pathname ?? '/'}${newSp.size > 0 ? '?' + newSp.toString() : ''}`,
		)
	}

	return (
		<div className="inline-block w-full" key="category-select">
			<select
				className={cn(searchBoxFilterStyle, 'appearance-none rounded-br-3xl')}
				value={selectedCategories?.[0] || ''}
				onChange={handleChange}
				aria-label={t('misc_category')}
			>
				<option value="all">{t('misc_all_categories')}</option>
				{categories.map(category => (
					<option key={category.alias} value={category.alias}>
						{category.name || capitalizeText(category.alias)}
					</option>
				))}
			</select>
		</div>
	)
}
